var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-home-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0698 8.20407L12.6228 1.48707C12.4461 1.34623 12.2268 1.26953 12.0008 1.26953C11.7748 1.26953 11.5555 1.34623 11.3788 1.48707L2.93078 8.20407C2.69533 8.39135 2.50517 8.62933 2.37444 8.90029C2.24372 9.17126 2.17582 9.46822 2.17578 9.76907V19.1871C2.17578 19.8236 2.42864 20.434 2.87873 20.8841C3.32881 21.3342 3.93926 21.5871 4.57578 21.5871H10.0008V16.8351C10.0008 16.5699 10.1061 16.3155 10.2937 16.128C10.4812 15.9404 10.7356 15.8351 11.0008 15.8351H13.0008C13.266 15.8351 13.5204 15.9404 13.7079 16.128C13.8954 16.3155 14.0008 16.5699 14.0008 16.8351V21.5871H19.4248C20.0613 21.5871 20.6718 21.3342 21.1218 20.8841C21.5719 20.434 21.8248 19.8236 21.8248 19.1871V9.77007C21.8247 9.46922 21.7568 9.17226 21.6261 8.90129C21.4954 8.63033 21.3052 8.39235 21.0698 8.20507",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeMono);
export default __webpack_public_path__ + "static/media/icon-home-mono.52587d90e963dc87df332b6c15b68010.svg";
export { ForwardRef as ReactComponent };